
import OuterComponent from "../components/OuterComponent";
export default function Demographics() {
  return(
  <OuterComponent>
    
  </OuterComponent>
  );
}
